/*
 * Category quick-links for the header "All categories" search dropdown.
 *
 * The dropdown's default behavior only affects results once a keyword is
 * typed and the search form is submitted — selecting a category by itself
 * does not navigate anywhere. For every category we now send the shopper
 * straight to a relevant page:
 *   - Categories with a matching, verified collection go straight there.
 *   - Any other category falls back to a real keyword search using the
 *     category name itself as the query (a non-empty "q" always returns
 *     results, unlike the default empty-query behavior).
 *
 * Implemented as a single delegated, capture-phase click listener so it
 * works regardless of how many times the header-search snippet is
 * rendered (desktop/mobile) and runs before Alpine's own click handler.
 *
 * IMPORTANT: the theme reuses the same ".select-option[data-select-value]"
 * markup for other pickers (e.g. the language selector), so matches are
 * scoped to elements inside ".header-search-refined" — the category
 * dropdown specifically — to avoid hijacking unrelated pickers.
 */
(function () {
  if (window.__wbCategoryQuickLinksInit) return;
  window.__wbCategoryQuickLinksInit = true;

  var DEFAULT_LABEL = "All categories";

  var categoryLinks = {
    "BBL Machine": "/collections/vcuum-butts-lift-bbl",
    "Body Composition Analyzer": "/products/wikbeauty-body-composition-analyzer-body-viberation-device",
    "Cavitation": "/collections/cavitationmachine",
    "cavitation": "/collections/cavitationmachine",
    "Cryolipolysis": "/collections/cryolipolysis",
    "Emslim": "/collections/emslimmachines",
    "Hifu": "/collections/hifu",
    "Hydrafacial": "/collections/hydrafacial",
    "Microneedle": "/collections/microneedle-machines",
    "Shockwave Therapy Equipment": "/collections/shockwave-therapy-machines",
    "Lipo Laser": "/collections/5dlipo-laser",
    "Physiotherapy Equipment": "/collections/pressotherapy-machines",
    "Fibroblast Pen Machine": "/collections/pressotherapy-machines",
    "Psychotherapy": "/collections/pressotherapy-machines",
    "Infrared Lights Therapy": "/collections/pressotherapy-machines",
    "Sauna Blanket": "/collections/pressotherapy-machines"
  };

  document.addEventListener(
    "click",
    function (event) {
      var option = event.target.closest(".header-search-refined .select-option[data-select-value]");
      if (!option) return;

      var label = option.getAttribute("data-select-value");
      if (!label || label === DEFAULT_LABEL) return;

      event.preventDefault();
      event.stopPropagation();

      var url = categoryLinks[label];
      if (!url) {
        // No dedicated collection mapped yet — fall back to a real keyword
        // search using the category name, which (unlike the default empty
        // query) actually returns results.
        url = "/search?q=" + encodeURIComponent(label) + "&type=product";
      }
      window.location.href = url;
    },
    true
  );
})();
